<template>
  <div :class="['select-group', props.class]">{{ props.label }}</div>
  <SelectGroup v-bind="delegatedProps">
    <slot />
  </SelectGroup>
</template>

<script setup>
import { computed } from 'vue'
import { SelectGroup } from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
  label: { type: String, required: true },
})

const delegatedProps = computed(() => {
  const { class: _, label, ...delegated } = props

  return delegated
})
</script>

<style scoped>
.select-group {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: var(--gu-dropdown-item-padding-y) var(--gu-dropdown-item-padding-x);
  padding-left: 1rem;
}
</style>
